import * as React from "react";
import "../Styles/style.css";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Popper from "../../images/party-celebration.json";
import Lottie from "lottie-react";
import WinnerCar from "../../images/WINING-VECTOR.png";
import { AuthContext } from "../../context/AuthContext";
import TimesUp from "../../images/times-up.png";
import { useHistory } from "react-router-dom";

const WinnerAnounced = ({ open, onClose, Winner }) => {
  const { user } = React.useContext(AuthContext);

  const history = useHistory();

  if (user?.id === Winner?.userId) {

    setTimeout(() => {
      history.push(`/won-bids`);
    }, 4000);
    
    return (
      <>
        <Modal
          open={open}
          disableAutoFocus={true}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="Fw-popups"
        >
          <Box className="winner-modal ">
            <div
              className=" position-absolute w-100 winnerSvg"
            >
              <Lottie animationData={Popper} loop={false} />
            </div>
            <Box className=" position-relative p-3 p-md-4 bg-white winner">
              <div className="modalBody_area successBox  px-2 text-center ">
                <img
                  style={{ height: 160 }}
                  src={WinnerCar}
                  className="mb-4"
                  alt="confirm"
                  srcSet=""
                />
                <h4 style={{ color: "#20409a" }} className="pb-2 fs-3 fw-700 ">
                  Congratulations {user?.name}
                </h4>
                <h5
                  style={{ textTransform: "unset", fontSize: 18 }}
                  className="pb-2 "
                >
                  You are the winner of{" "}
                </h5>
                <h3 style={{ textTransform: "unset" }} className="pb-2 fs-3 ">
                  {Winner?.makeName} {Winner?.modelName} {Winner?.yearName}
                </h3>
              </div>
            </Box>
          </Box>
        </Modal>
      </>
    );
  } else {
    setTimeout(() => {
      history.push(`/loss-bids`);
    }, 4000);

    return (
      <>
        <Modal
          open={open}
          disableAutoFocus={true}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="Fw-popups"
        >
          <Box className="winner-modal ">
            <Box className=" position-relative p-3 p-md-4 bg-white winner">
              <div className="modalBody_area successBox  px-2 text-center ">
                <img
                  style={{ height: 160 }}
                  src={TimesUp}
                  className="mb-4"
                  alt="confirm"
                  srcSet=""
                />
                <h4 className="pb-2 fs-3 fw-700">Auction has been ended!</h4>
                <h5
                  style={{ textTransform: "unset", fontSize: 18 }}
                  className="pb-2 "
                >
                  Better luck next time.{" "}
                </h5>
                <p style={{ fontSize: 14 }}>Redirecting.. in 3 seconds</p>
              </div>
            </Box>
          </Box>
        </Modal>
      </>
    );
  }
};

export default WinnerAnounced;
